import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=4f9e232b"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateNewOrder.vue?vue&type=style&index=0&id=4f9e232b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports